import * as Config from '../../../config';
import React, {useEffect} from 'react';
import { connect, useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import './Card.css';

import {
  setSelectedItems
} from "../../../actions/index";

import CoverSplit from './CoverSplit';

function ConnectedCardPartial({
    title = null, images, style, audio, dragEnabled, beginDrag, endDrag, type,
    publishDate = null, showTitle = false, updatedCallback = null, category = null,
    className, children, isUpdated = false,
    setSelectedItems, storeRoute
  }) {

  // v11 (rollback) :
  // const [{ opacity }, dragRef, preview] = useDrag({
  //   item: { ...audio, type /*, idParent*/ },
  //   begin: beginDrag || (() => { setSelectedItems([audio])} ),
  //   end: endDrag || ((item, monitor) => { setSelectedItems([]) }),
  //   collect: (monitor) => ({
  //     opacity: monitor.isDragging() ? 0.5 : 1
  //   })
  // })
  const [{ opacity }, dragRef, preview] = useDrag({
    type,
    item: () => {
      (beginDrag || (() => { setSelectedItems([audio]) }))();
      return { ...audio, type /*, idParent*/ };
    },
    end: endDrag || ((item, monitor) => { setSelectedItems([]) }),
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.5 : 1
    })
  })

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [preview])

  // Double Tap OR Normal Click OR Touch
  const allowAccess = useSelector(state => state.allowAccess);
  const openLink = () => {
    if (audio.uri && allowAccess) {
      storeRoute.goTo(audio.uri);
      if (updatedCallback) { updatedCallback(); }
    } 
  }

  return (
    <div id={`refC-${(audio) ? ((audio.ref) ? audio.ref : audio.id) : null}`} ref={(dragEnabled && !Config.TOUCH_ENABLED) ? dragRef : null} className={`CardBP ${className}`} style={{...style, height: (style.height && style.height - 10), opacity, cursor: (dragEnabled) ? `grab` : `pointer`}}>
      {((audio && dragEnabled)) && (
        <div className={`oo only-cover`} style={{ width: style.width, height: style.width }}>
          <div onClick={openLink} style={{ width: style.width, height: style.width, opacity: 0 }} />
        </div>
      )}
      <CoverSplit name={title} images={images} size={style.width} onlyCover={false} onClick={openLink} />
      { showTitle && (
          <div className='flexRow' style={{gap: 2, minHeight: 42}}>   
            <span id={`title-refC-${(audio) ? ((audio.ref) ? audio.ref : audio.id) : null}`} className={`card-title ${type} type-medium`} style={{paddingTop: 7}} onClick={openLink}>{title}</span> 
          </div>
        )
      }
      <div className='flexRow' style={{gap: 2, marginLeft: 4}}>
        { (isUpdated) && <div className={'show-update'} /> }      
        { ((!showTitle && isUpdated) || showTitle) && (
          <span id={`link-refC-${(audio) ? ((audio.ref) ? audio.ref : audio.id) : null}`} className={`card-title ${type} ${showTitle && 'dj'} type-medium`} style={{ paddingTop: 7, color: ( isUpdated) ? Config.BRAND_PRIMARY : Config.TYPE_LIGHT }} onClick={openLink}>
            { (isUpdated) ? 'Updated' : ''}
          </span>
        ) }
      </div>
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  )
}

ConnectedCardPartial.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  publishDate: PropTypes.string,
  updatedCallback: PropTypes.func,
  category: PropTypes.string,
  images: PropTypes.array.isRequired,
  audio: PropTypes.object,
  style: PropTypes.object,
  dragEnabled: PropTypes.bool.isRequired,
  beginDrag: PropTypes.func,
  endDrag: PropTypes.func,
  className: PropTypes.string,
}

const CardPartial = connect(
  state => ({
    storeRoute: state.storeRoute
  }),
  dispatch => ({
    setSelectedItems: items => dispatch(setSelectedItems(items)),
  }) )
(ConnectedCardPartial);

export default CardPartial;
